module.exports = __webpack_public_path__ + "img/smallAi.3a72a5e3.svg";